module.exports = __webpack_public_path__ + "media/bootstrap-icons/rss-2b935c94.svg";